import { FileWarning, CheckCircle2, AlertCircle, XCircle } from 'lucide-react';
import { Badge } from '@/shared/ui/badge';
import type { ComplaintStatus } from '@/core/api';

interface ComplaintStatusBadgeProps {
  status: ComplaintStatus;
  showIcon?: boolean;
}

/**
 * Color-coded status badge for customer complaints.
 */
export const ComplaintStatusBadge = ({ status, showIcon = true }: ComplaintStatusBadgeProps) => {
  const config = {
    draft: {
      label: 'Draft',
      variant: 'secondary' as const,
      icon: FileWarning,
      className: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
    },
    complaint_recorded: {
      label: 'Recorded',
      variant: 'outline' as const,
      icon: AlertCircle,
      className: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-800',
    },
    in_progress: {
      label: 'In Progress',
      variant: 'default' as const,
      icon: AlertCircle,
      className: 'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300',
    },
    closed: {
      label: 'Closed',
      variant: 'outline' as const,
      icon: CheckCircle2,
      className: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-800',
    },
  };

  const { label, variant, icon: Icon, className } = config[status];

  return (
    <Badge variant={variant} className={className}>
      {showIcon && <Icon className="h-3 w-3 mr-1" />}
      {label}
    </Badge>
  );
};
